import { Link } from 'react-router-dom';

export const BrandLink = ({ slot, homePath = '/', className = '', isLogo = false, children }) => {

    const EXTERNAL = slot?.externalLink;
    const INTERNAL = slot?.internalLink || homePath;

    if (EXTERNAL) {
        return (
            <a href={EXTERNAL} target="_blank" rel="noopener noreferrer"
                className={className} data-has-logo={isLogo} title={slot?.title ?? ''} >
                {children}
            </a>
        );
    }

    return (
        <Link to={INTERNAL} className={className} data-has-logo={isLogo} title={slot?.title ?? ''}>
            {children}
        </Link>
    );
};
